import React, { useState } from 'react'
import axios from "axios";
import publisherregisterStyle from './PublishersRegisterPage.module.css'
import PublishersHeader from '../../components/Header/PublishersHeader'
import { FaEye, FaEyeSlash } from 'react-icons/fa';
import { useMediaQuery } from 'react-responsive';
import PublisherRegisterMobilStepOne from './PublisherRegisterMobilStepOne';
import PublisherRegisterMobilStepTwo from './PublisherRegisterMobilStepTwo';
import Swal from "sweetalert2";
import { useNavigate } from "react-router-dom";
require('typeface-poppins')

export default function PublishersRegisterPage() {

  const isMobile = useMediaQuery({ query: '(max-width: 768px)' });

  // Password Eyes
  const [isPasswordVisible, setPasswordVisible] = useState(false);

  const togglePasswordVisibility = () => {
    setPasswordVisible(!isPasswordVisible);
  };

  // Confirm Password Eyes
  const [isCPasswordVisible, setCPasswordVisible] = useState(false);

  const toggleCPasswordVisibility = () => {
    setCPasswordVisible(!isCPasswordVisible);
  };


  // Define state for the current step
  const [currentStep, setCurrentStep] = useState(1);
  const [isSubmitted, setIsSubmitted] = useState(false);
  const navigate = useNavigate();
  const [previewImage, setPreviewImage] = useState(null);
  // Define total steps in the process
  const totalSteps = 2;

  // Handle the next step
  const nextStep = () => {
    if (currentStep < totalSteps) {
      setCurrentStep(currentStep + 1);
    }
  };

  // Handle the previous step
  // const prevStep = () => {
  // if (currentStep > 1) {
  // setCurrentStep(currentStep - 1);
  // }
  // };

  // Handle the form submission
  const steppersubmit = () => {
    // Logic for form submission can go here
    setIsSubmitted(true);
    // console.log('Form submitted');
  };

  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    position: "",
    email: "",
    phone: "",
    password: "",
    confirmPassword: "",
    image: null,
  });

  const formatPhoneNumber = (value) => {
    const cleaned = value.replace(/\D/g, "");
    const match = cleaned.match(/^(\d{0,3})(\d{0,3})(\d{0,4})$/);

    if (!match) return value;

    let formatted = match[1];
    if (match[2]) formatted += "-" + match[2];
    if (match[3]) formatted += "-" + match[3];

    return formatted;
  };


  const handleChange = (e) => {
    const { name, value } = e.target;

    if (name === "phone") {
      setFormData(prev => ({
        ...prev,
        phone: formatPhoneNumber(value),
      }));
    } else {
      setFormData(prev => ({
        ...prev,
        [name]: value,
      }));
    }
  };


  // const handleFileChange = (e) => {
  //   setFormData(prev => ({ ...prev, image: e.target.files[0] }));
  // };

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setFormData(prev => ({ ...prev, image: file }));
      setPreviewImage(URL.createObjectURL(file));
    }
  };



  const handleSubmit = async (e) => {
    e.preventDefault();

    if (formData.password !== formData.confirmPassword) {
      alert("Passwords do not match!");
      return;
    }

    const data = new FormData();
    Object.keys(formData).forEach((key) => {
      if (key === "phone") {
        // ✅ Remove hyphens before sending
        data.append("phone", formData.phone.replace(/\D/g, ""));
      } else {
        data.append(key, formData[key]);
      }
    });

    try {
      const res = await axios.post(`${process.env.REACT_APP_API_BASE_URL}authormeetapi/register_publisher.php`, data, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });

      if (res.data.status == 'success') {
        const pId = res.data.id;
        Swal.fire({
          title: "Thankyou you for your submission",
          text: "Thankyou for registering. Please check your email for login information.",
          icon: "success",
          timer: 2000,
          showConfirmButton: false,
        }).then((data) => {
          navigate(`/PublisherProfilePage/${pId}`);
        });
      }

      //alert(res.data.message);
    } catch (err) {
      /*console.error(err);
      alert("Registration failed"); */
      let errorMessage = "Registration failed. Please try again.";

      // ✅ Read backend error message safely
      if (err.response && err.response.data) {
        errorMessage =
          err.response.data.message ||
          err.response.data.error ||
          errorMessage;
      }

      Swal.fire({
        title: "Registration Failed!",
        text: errorMessage,
        icon: "error",
        confirmButtonText: "OK",
      });
    }
  };

  return (
    <>
      <PublishersHeader />
      {isMobile ? (
        <div className={publisherregisterStyle.mobilpublisherregister}>
          <div className='container'>
            <div className='row'>
              <div className='col-xl-12'>
                <div className={publisherregisterStyle.publisherstepperWrapper}>
                  <div className={publisherregisterStyle.publisherstepperContent}>
                    {currentStep === 1 && <PublisherRegisterMobilStepOne />}
                    {currentStep === 2 && <PublisherRegisterMobilStepTwo />}
                  </div>
                  <div className={`${publisherregisterStyle.publisherstepperFooter} mb-5`}>

                    {/* <button onClick={prevStep} disabled={currentStep === 1}> Back </button> */}
                    {currentStep === totalSteps ? (
                      <button className={`${publisherregisterStyle.publishersubmitStepper} btn btn-warning w-100`} onClick={steppersubmit} disabled={isSubmitted}>
                        {isSubmitted ? 'Submitted' : 'Submit'}
                      </button>
                    ) : (
                      <button className={`${publisherregisterStyle.publishernextStepper} btn btn-warning w-100`} onClick={nextStep} disabled={currentStep === totalSteps}>
                        Next
                      </button>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      ) : (
        <div className={publisherregisterStyle.publisherregisterpage}>
          <div className="container h-100">
            <div className="row justify-content-center h-100 align-items-start">
              <div className="col-xl-8 col-xxl-8">
                <h3> Welcome! Sign up to Join! </h3>
                <div className={publisherregisterStyle.publishercationContent}>
                  <form onSubmit={handleSubmit}>
                    <div className="row mb-3 justify-content-center">
                      <div className="col-xl-9 col-xxl-9">
                        <h6> Publisher Information </h6>
                        <div className="row mb-3">
                          <div className="col-md-6">
                            <label className={`${publisherregisterStyle.publisherLabel} form-label`}>First Name</label>
                            <input type="text" className={`${publisherregisterStyle.publisherInput} form-control`} name="firstName" onChange={handleChange} required />
                          </div>
                          <div className="col-md-6">
                            <label className={`${publisherregisterStyle.publisherLabel} form-label`}>Last Name</label>
                            <input type="text" className={`${publisherregisterStyle.publisherInput} form-control`} name="lastName" onChange={handleChange} required />
                          </div>
                        </div>
                        <div className="row mb-3">
                          <div className="col-md-12">
                            <label className={`${publisherregisterStyle.publisherLabel} form-label`}>Name of Publisher</label>
                            <input type="text" className={`${publisherregisterStyle.publisherInput} form-control`} name="fullname" onChange={handleChange} required />
                          </div>
                        </div>
                        <div className="row mb-3">
                          <div className="col-md-12">
                            <label className={`${publisherregisterStyle.publisherLabel} form-label`}>Email Address</label>
                            <input type="email" className={`${publisherregisterStyle.publisherInput} form-control`} name="email" onChange={handleChange} required />
                          </div>
                        </div>
                        <div className="row mb-3">
                          <div className="col-md-12">
                            <label className={`${publisherregisterStyle.publisherLabel} form-label`}>Phone:</label>
                            <input type="tel" className={`${publisherregisterStyle.publisherInput} form-control`} name="phone" placeholder="123-456-7890" value={formData.phone} onChange={handleChange} maxLength={12} required />
                          </div>
                        </div>
                      </div>
                      <div className="col-xl-3 col-xxl-3">
                        <div className={publisherregisterStyle.publisherimageCircle}>
                          <div className={publisherregisterStyle.publishercircleEdit}>
                            <input type='file' id="publisherimageUploads" className={publisherregisterStyle.pulisherInputcircle} accept=".png, .jpg, .jpeg" name="image"
                              onChange={handleFileChange} />
                            <label for="publisherimageUploads"></label>
                          </div>
                          <div className={publisherregisterStyle.publishercirclePreview}>
                            <div id="publisherimagePreview">
                              {previewImage && (
                                <img
                                  src={previewImage}
                                  alt="Preview"
                                  style={{ width: "100%", height: "auto", borderRadius: "50%" }}
                                />
                              )}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="row mb-3">
                      <div className="col-xl-9 col-xxl-9">
                        <h6 className='pb-4'> Password </h6>
                        <div className="row">
                          <div className="mb-3">
                            <label className={`${publisherregisterStyle.publisherLabel} form-label`}> Choose your password </label>
                            <div className={publisherregisterStyle.publisherpasswordwrapper}>
                              <input type={isPasswordVisible ? "text" : "password"} id="password-field" className={`${publisherregisterStyle.publisherInput} form-control`} name="password" onChange={handleChange} required />
                              <div className={publisherregisterStyle.publishertogglebutton} onClick={togglePasswordVisibility}>
                                {isPasswordVisible ? <FaEyeSlash /> : <FaEye />}
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="row">
                          <div className="mb-3">
                            <label className={`${publisherregisterStyle.publisherLabel} form-label`}> Confirm your password </label>
                            <div className={publisherregisterStyle.publisherpasswordwrapper}>
                              <input type={isCPasswordVisible ? "text" : "password"} id="password-field1" className={`${publisherregisterStyle.publisherInput} form-control`} name="confirmPassword" onChange={handleChange} required />
                              <div className={publisherregisterStyle.publishertogglebutton} onClick={toggleCPasswordVisibility}>
                                {isCPasswordVisible ? <FaEyeSlash /> : <FaEye />}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="col-xl-3 col-xxl-3"></div>
                    </div>
                    <div className="row">
                      <div className="text-center mb-3 mt-4">
                        <button className={`${publisherregisterStyle.publishersubmitButton} btn btn-warning `}>SUBMIT</button>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  )
}